import cx from 'classnames';
import OrganicLargeBottom from 'themes/organic/assets/organic_large_bottom.svg';
import OrganicLargeTop from 'themes/organic/assets/organic_large_top.svg';
import { TexturedCircle } from 'themes/organic/components';

import { ContentContainer } from '../../ContentContainer';
import { Subtitle } from '../../Subtitle/Subtitle';

import s from './LongContainedSection.module.css';

type TProps = {
  id: string;
  title?: string;
  className?: string;
  shapeClassName?: string;
  contentClassName?: string;
  children: React.ReactNode;
  showCircle?: boolean;
};

export const LongContainedSection = ({
  id,
  title,
  children,
  className,
}: TProps) => (
  <section id={id} className={cx(s.root, className)}>
    <ContentContainer>
      <TexturedCircle className={s.texturedCircle} />
    </ContentContainer>
    <div className={s.shapeContainer}>
      <OrganicLargeTop />
    </div>
    <div className={s.middleContainer}>
      <div className={s.middleInner}>
        <ContentContainer>
          <div className={s.content}>
            <Subtitle className={s.heading}>{title}</Subtitle>
            {children}
          </div>
        </ContentContainer>
      </div>
    </div>
    <div className={s.shapeContainer}>
      <OrganicLargeBottom />
    </div>
  </section>
);
